import { DASHBOARD_CONTENT_DETAILS } from '../config/api';
import { apiCall } from './api';

// Get dashboard content by ID
export const getDashboardContent = async (id = 1) => {
  try {
    const endpoint = DASHBOARD_CONTENT_DETAILS.replace('{id}', id);
    const response = await apiCall(endpoint, {
      method: 'GET'
    });
    return response;
  } catch (error) {
    console.error('Error fetching dashboard content:', error);
    return {
      success: false,
      error: error.message || 'Failed to fetch dashboard content',
      data: null
    };
  }
};

// Update dashboard content by ID
export const updateDashboardContent = async (contentData, id = 1) => {
  try {
    const endpoint = DASHBOARD_CONTENT_DETAILS.replace('{id}', id);
    const response = await apiCall(endpoint, {
      method: 'PUT',
      data: contentData
    });
    return response;
  } catch (error) {
    console.error('Error updating dashboard content:', error);
    return {
      success: false,
      error: error.message || 'Failed to update dashboard content',
      data: null
    };
  }
};

